// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","wrapper":"TKB8i","s4lwrapper":"b6fk3","s4Lwrapper":"b6fk3"};